import { Model } from '@vuex-orm/core'

export default class Questionform extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'questionforms'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      type: this.attr(null),
      key: this.attr(null),
      fixed: this.attr(null),
      subject: this.attr(null),
      body: this.attr(null),
      time_limit: this.attr(null),
      questions: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Questionform.js